/*
 * File: VoidConfirmSchema.ts
 * Author: Austin Robinson
 * Date Created: 4/7/2025
 * Copyright (c) DrivingDoc 2025
 */

import { z } from "zod";

export const VoidSchema = z.object({
  reason: z.string().trim().nullable().default(null),
});

export type VoidFormValues = z.infer<typeof VoidSchema>;
